if (!customElements.get('age-verification-pop-up')) {
  customElements.whenDefined('modal-dialog').then(() => {
    class AgeVerificationPopUp extends Modal {
      constructor() {
        super();
        this.cookie = `${this.id}-nz18-v4`;
        this.declaration = this.querySelector('.js-age-declaration');
        this.proceedButton = this.querySelector('.js-close-modal');
        this.cancelButton = this.querySelector('.js-cancel-button');
        this.cancelMessage = this.querySelector('.js-cancel-message');
        this.accepted = false;
        this.declined = false;
        if (this.proceedButton) this.proceedButton.disabled = true;
        if (this.declaration) {
          this.declaration.checked = false;
          this.declaration.addEventListener('change', () => {
            if (this.proceedButton) this.proceedButton.disabled = this.declined || !this.declaration.checked;
          });
        }
        if (this.cancelButton) this.cancelButton.addEventListener('click', () => {
          this.declined = true;
          if (this.declaration) { this.declaration.checked = false; this.declaration.disabled = true; }
          if (this.proceedButton) this.proceedButton.disabled = true;
          if (this.cancelMessage) this.cancelMessage.hidden = false;
          if (this.cancelButton) trapFocus(this, this.cancelButton);
        });
        if (Shopify.designMode) {
          document.addEventListener('shopify:section:select', (evt) => {
            if (evt.target === this.closest('.shopify-section')) this.open();
          });
          document.addEventListener('shopify:section:deselect', () => this.close());
        } else {
          this.checkExpiry = () => {
            clearTimeout(this.expiryTimer);
            const prefix = encodeURIComponent(this.cookie) + '=';
            const cookie = document.cookie.split(';').map((part) => part.trim()).find((part) => part.startsWith(prefix));
            const acceptedAt = cookie ? Number(cookie.slice(prefix.length)) : 0;
            const now = Date.now();
            const remaining = acceptedAt > 0 && acceptedAt <= now ? acceptedAt + 86400000 - now : 0;
            if (remaining > 0) {
              this.expiryTimer = setTimeout(this.checkExpiry, remaining);
            } else if (!this.promptOpen) {
              this.open();
            }
          };
          window.addEventListener('pageshow', this.checkExpiry);
          window.addEventListener('focus', this.checkExpiry);
          this.checkExpiry();
        }
      }
      open(opener) {
        this.promptOpen = true;
        this.accepted = false;
        this.declined = false;
        if (this.declaration) { this.declaration.checked = false; this.declaration.disabled = false; }
        if (this.proceedButton) this.proceedButton.disabled = true;
        if (this.cancelMessage) this.cancelMessage.hidden = true;
        super.open(opener);
        this.removeEventListener('keyup', this.keyupHandler);
      }
      close() {
        if (this.accepted || Shopify.designMode) { this.promptOpen = false; super.close(); }
      }
      handleClick(evt) {
        if (!evt.target.matches('.js-close-modal') || this.declined || !this.declaration?.checked) return;
        this.accepted = true;
        document.cookie = `${encodeURIComponent(this.cookie)}=${Date.now()}; Max-Age=86400; path=/; SameSite=Lax; Secure`;
        this.close();
        if (this.checkExpiry) this.checkExpiry();
      }
    }
    customElements.define('age-verification-pop-up', AgeVerificationPopUp);
  });
}
